import { Button, ButtonType } from "@ui/common/buttons/Button"
import { FormField, FormFieldNote } from "@ui/common/form/FormField";
import { TextArea } from "@ui/common/form/TextArea";
import { Grid, GridGap } from "@ui/common/grids/Grid";
import { Modal, ModalBody, ModalButtons, ModalContent, ModalHeader, ModalHeaderSubTitle, ModalHeaderTitle } from "@ui/common/Modal";
import React from "react";


export function OnHoldModal({
    isVisible,
    onClose,
    onHoldChanged
}: {
    isVisible: boolean;
    onClose: () => void;
    onHoldChanged: (reason: string) => void;
}): JSX.Element {
    const [reasonForHold, setReasonForHold] = React.useState<string>("");
    
    function handleCloseEvent() {
        onClose();
        setReasonForHold("");
    }

    return (
        <Modal isVisible={isVisible} onClose={handleCloseEvent} useContentTag={true}>
            <ModalContent>
                <ModalHeader>
                    <ModalHeaderTitle>Put Work Order On Hold</ModalHeaderTitle>
                </ModalHeader>
                <ModalBody>
                    <Grid gap={GridGap.Medium} columns={1}>
                        <FormField>
                            <FormFieldNote>
                                Please provide a reason for putting this work order on hold. This will help track why work was stopped.
                            </FormFieldNote>
                        </FormField>                    
                        <FormField label="Reason for Hold *">
                            <TextArea                                
                                    maxLength={1000}
                                    value={reasonForHold}                                
                                    onChange={(value) => setReasonForHold(value)}
                                    placeholder="Explain why this work order needs to be put on hold..."
                                />
                        </FormField>
                    </Grid>
                </ModalBody>
                <ModalButtons>
                    <Button label="Cancel" onClick={handleCloseEvent} />
                    <Button label="Put On Hold" onClick={() => {onHoldChanged(reasonForHold); handleCloseEvent(); }} isEnabled={reasonForHold.trim() !== ""} />
                </ModalButtons>
            </ModalContent>
        </Modal>
    );
}
